import moment from 'moment';

const NUMBER_OF_DAYS_TO_SHOW = 4;

const dayNamesFormat = 'dddd';

export const TODAY = moment();

export const FORMATED_TODAY = TODAY.format('YYYY/MM/DD HH:mm:ss');

const TODAY_PLACEHOLDER_TEXT = 'Today';

const getCustomDayFormat = (startdate, index, format) => {
  const dayName = moment(startdate, 'DD-MM-YYYY')
    .add(index, 'days')
    .format(format)
    .substring(0, 3);
  const dayNumber = moment(startdate, 'DD-MM-YYYY')
    .add(index, 'days')
    .format('D');
  return `${dayName}${dayNumber}`;
};

const getNextDayByFormat = (startdate, index, format = 'DD-MM-YYYY') => {
  const day = moment(startdate, format).add(index, 'days');
  return day;
};

export const getWeekByDate = ({
  startdate = TODAY,
  numberOfDays = NUMBER_OF_DAYS_TO_SHOW,
  format = dayNamesFormat,
} = {}) => {
  const isfirstDayToday = startdate.isSame(TODAY);
  const week = [];
  for (let index = 0; index < numberOfDays; index++) {
    let day = getCustomDayFormat(startdate, index, format);
    if (index === 0 && isfirstDayToday) {
      day = TODAY_PLACEHOLDER_TEXT;
    }
    week.push(day);
  }
  return week;
};

export const isDayToday = (day) => {
  const formatedDay = moment(day).format('DD-MM-YYYY');
  const formatedToday = TODAY.format('DD-MM-YYYY');
  return formatedDay === formatedToday;
};

export const getWeekObjArrByDate = ({
  startdate = TODAY,
  numberOfDays = NUMBER_OF_DAYS_TO_SHOW,
  format = dayNamesFormat,
} = {}) => {
  const isfirstDayToday = startdate.isSame(TODAY);
  const week = [];
  for (let index = 0; index < numberOfDays; index++) {
    const dayName = getCustomDayFormat(startdate, index, format);
    let dayObj = {
      day: getNextDayByFormat(startdate, index, format).format(
        'YYYY/MM/DD HH:mm:ss'
      ),
      dayName,
    };
    if (index === 0 && isfirstDayToday) {
      dayObj = {
        day: TODAY.format('YYYY/MM/DD HH:mm:ss'),
        dayName: TODAY_PLACEHOLDER_TEXT,
      };
    }
    week.push(dayObj);
  }
  return week;
};

export const getFormatedDate = ({ date, format = 'DD-MM-YYYY' } = {}) => {
  return moment(date, 'YYYY/MM/DD HH:mm:ss').format(format);
};

export const getNextDaysFrom = ({
  startdate = TODAY,
  format = 'YYYY:MM:DD HH:mm:ss',
  daysToAdd,
} = {}) => {
  const getDay = (numberOfDay) => {
    return moment(startdate, 'YYYY/MM/DD HH:mm:ss')
      .add(numberOfDay, 'days')
      .format(format);
  };
  const isfirstDayToday = startdate.isSame(TODAY);
  const nextDays = [];
  for (let index = 0; index < daysToAdd; index++) {
    const day = getDay(index);
    if (index === 0 && isfirstDayToday) {
      nextDays.push(TODAY.format(format));
    } else {
      nextDays.push(day);
    }
  }
  return nextDays;
};
